import { clearUserInput, NavigationState, saveStep, Flow, useNavigationStore } from '@store';
import { useLogger } from '@hooks';
import { useDispatch } from 'react-redux';
import { integratedSolutionFlowPath, noFlowPath, subscriptionFlowPath } from '@navigation';

interface NavigationFlow {
	flow: string[];
	type: Flow;
}
interface NavigationStepOutput {
	current: string;
	previous?: string;
	getFlow: (currentStep: string) => NavigationFlow;
	setNavigationStep: (currentStep: string, previousStep?: string) => void;
}
export const useNavigationStep = (): NavigationStepOutput => {
	const dispatch = useDispatch();
	const logger = useLogger();
	const { current, previous, flow } = useNavigationStore();

	const getFlow = (currentStep: string): NavigationFlow => {
		let flowPath: string[];
		let typeFlow: Flow;

		if (subscriptionFlowPath.includes(currentStep)) {
			flowPath = subscriptionFlowPath;
			typeFlow = 'subscription';
		} else if (integratedSolutionFlowPath.includes(currentStep)) {
			flowPath = integratedSolutionFlowPath;
			typeFlow = 'integratedSolution';
		} else {
			flowPath = noFlowPath;
			typeFlow = 'noFlow';
		}

		return { flow: flowPath, type: typeFlow };
	};

	const setNavigationStep = (currentStep: string) => {
		const flowReturned: NavigationFlow = getFlow(currentStep);

		logger('useNavigationStep > setNavigationStep > ', {
			current: currentStep,
			previous: current,
			flowOfCurrentStep: flowReturned.type,
			flowOnStore: flow,
		});

		const data: NavigationState = {
			current: currentStep,
			previous: current,
			flow: flowReturned.type,
		};
		dispatch(saveStep(data));
		if (
			flow !== flowReturned.type &&
			flow !== 'noFlow' &&
			flowReturned.type !== 'noFlow' &&
			(flow === 'integratedSolution' || flow === 'subscription')
		) {
			dispatch(clearUserInput());
		}
	};

	return {
		current,
		previous,
		setNavigationStep,
		getFlow,
	};
};
